import MuiAutocomplete from '@mui/material/Autocomplete';
import clsx from 'clsx';
import type { ComponentProps, Ref } from 'react';
import { forwardRef } from 'react';

export const Autocomplete = forwardRef(function CustomComponent<T>(
  { disabled, readOnly, ...props }: ComponentProps<typeof MuiAutocomplete<T>>,
  ref: Ref<unknown>,
) {
  return (
    <MuiAutocomplete
      ref={ref}
      readOnly={readOnly}
      disabled={disabled}
      classes={{ root: clsx({ 'Mui-readOnly': readOnly }) }}
      {...props}
      tabIndex={props.tabIndex}
    />
  );
});

export const UnclearableAutocomplete = forwardRef(function CustomComponent<T>(
  {
    disabled,
    readOnly,
    ...props
  }: ComponentProps<typeof MuiAutocomplete<T, false, true>>,
  ref: Ref<unknown>,
) {
  return (
    <MuiAutocomplete
      ref={ref}
      classes={{ root: clsx({ 'Mui-readOnly': readOnly }) }}
      disabled={disabled}
      readOnly={readOnly}
      disableClearable
      {...props}
      tabIndex={props.tabIndex}
    />
  );
});

export const MultipleAutocomplete = forwardRef(function CustomComponent<T>(
  props: ComponentProps<typeof MuiAutocomplete<T, true>>,
  ref: Ref<unknown> | undefined,
) {
  return (
    <MuiAutocomplete multiple ref={ref} {...props} tabIndex={props.tabIndex} />
  );
});
